import React from 'react'
import { Row } from 'antd'
import { useTranslation } from 'next-i18next'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import OffsetFieldForm from '../OffsetFieldForm/OffsetFieldForm'
import { setOffsetByExcelKeysSelected, offsetByExcelSelector } from 'src/features'
import OffsetStepsOptionalKeysForm from './OffsetStepsOptionalKeysForm/OffsetStepsOptionalKeysForm'

const SelectOffsetKeysForm: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const {
    offsetKeys,
    optionalFields: { fields, use_company_name_in_offset }
  } = useAppSelector(offsetByExcelSelector)


  return <>
    <Row>
      {/* Identifier Field */}
      <OffsetFieldForm
        errorKey={'identifierField'}
        value={offsetKeys.identifierField}
        title={t('developers.OffSet.IdentifierLabel')}
        placeholder={t('developers.OffSet.IdentifierPlaceholder')}
        handleChange={(value) => dispatch(setOffsetByExcelKeysSelected({ ...offsetKeys, identifierField: value }))}
      />

      {/* AmountCO2  Field */}
      <OffsetFieldForm
        errorKey={'amountCo2Field'}
        value={offsetKeys.amountCo2Field}
        title={t('developers.OffSet.AmountCO2Label')}
        placeholder={t('developers.OffSet.AmountCO2Placeholder')}
        handleChange={(value) => dispatch(setOffsetByExcelKeysSelected({ ...offsetKeys, amountCo2Field: value }))}
      />

      {/* CO2 Field */}
      <OffsetFieldForm
        showKeys={false}
        errorKey={'co2UnitField'}
        value={offsetKeys.co2UnitField}
        title={t('developers.OffSet.Co2Unit')}
        placeholder={t('developers.OffSet.Co2UnitPlaceholder')}
        handleChange={(value) => dispatch(setOffsetByExcelKeysSelected({ ...offsetKeys, co2UnitField: value }))}
      />
    </Row>

    <Row>
      {/* Email Field */}
      <OffsetFieldForm
        errorKey={'emailField'}
        value={offsetKeys.emailField}
        title={t('developers.OffSet.EmailField')}
        placeholder={t('developers.OffSet.EmailFieldPlaceholder')}
        handleChange={(value) => dispatch(setOffsetByExcelKeysSelected({ ...offsetKeys, emailField: value }))}
      />

      {!use_company_name_in_offset ? <>
        {/* Name Field */}
        <OffsetFieldForm
          errorKey={'nameField'}
          value={offsetKeys.nameField}
          title={t('developers.OffSet.NameField')}
          placeholder={t('developers.OffSet.NameFieldPlaceholder')}
          handleChange={(value) => dispatch(setOffsetByExcelKeysSelected({ ...offsetKeys, nameField: value }))}
        />

        {/* Last Name Field */}
        <OffsetFieldForm
          errorKey={'lastNameField'}
          value={offsetKeys.lastNameField}
          title={t('developers.OffSet.LastNameField')}
          placeholder={t('developers.OffSet.LastNameFieldPlaceholder')}
          handleChange={(value) => dispatch(setOffsetByExcelKeysSelected({ ...offsetKeys, lastNameField: value }))}
        />
      </> : <>
        {/* Company name Field */}
        <OffsetFieldForm
          errorKey={'companyNameField'}
          value={offsetKeys.companyNameField}
          title={t('developers.OffSet.CompanyName')}
          placeholder={t('developers.OffSet.CompaneNamePlaceholder')}
          handleChange={(value) => dispatch(setOffsetByExcelKeysSelected({ ...offsetKeys, companyNameField: value }))}
        />
      </>}
    </Row>

    {fields.length > 0 && <OffsetStepsOptionalKeysForm />}
  </>
}

export default SelectOffsetKeysForm
